<template>
  <v-main>
    <v-container class="py-10">
      <v-row align="center" justify="center">
        <v-col cols="12" md="5" sm="6" class="d-flex align-center">
          <v-card flat color="transparent">
            <v-card-text class="pa-0">
              <div
                class="slide-left-to-right"
                style="background-color: transparent !important"
              >
                <h2
                  class="gradient mb-4"
                  style="line-height: 1.2; background-color: transparent"
                >
                  Fale inglês até 70% mais rápido de forma flexível e
                  personalizada!
                </h2>

                <p class="poppins mb-6">
                  A Pitch é uma plataforma que conecta
                  <strong>alunos a professores licenciados</strong> de inglês,
                  oferecendo metodologia focada em
                  <strong>conversação, tecnologia</strong> e estrutura para um
                  aprendizado
                  <strong>flexível, eficiente e personalizado.</strong>
                </p>

                <v-btn
                  rounded
                  x-large
                  color="primary"
                  class="font-weight-bold text-none"
                  style="
                    font-size: 1.1rem;
                    height: auto;
                    min-height: 54px;
                    white-space: normal;
                  "
                  @click="openLink()"
                >
                  Conecte-se ao professor ideal para você!
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="1" class="hidden-sm-and-down"></v-col>

        <v-col
          cols="12"
          md="6"
          sm="6"
          style="background-color: transparent !important"
        >
          <v-img
            class="slide-right-to-left rounded-lg"
            style="background-color: transparent !important"
            contain
            elevation="0"
            max-height="500"
            src="@/assets/images/lets_talk-min.webp"
          />
        </v-col>
      </v-row>

      <v-row class="mt-12">
        <v-col
          cols="12"
          md="4"
          sm="4"
          v-for="(card, index) in infoCards"
          :key="index"
          class="d-flex"
        >
          <v-card
            elevation="1"
            class="infoCard slide-bottom-to-top flex-grow-1"
            style="border-radius: 15px"
          >
            <v-card-text class="fill-height d-flex align-center">
              <v-row dense align="center">
                <v-col cols="3" class="d-flex justify-center">
                  <v-icon color="primary" size="40">{{ card.icon }}</v-icon>
                </v-col>
                <v-col cols="9">
                  <h5
                    class="primary--text font-weight-bold mb-1"
                    style="font-size: 1.1rem"
                  >
                    {{ card.title }}
                  </h5>
                  <span
                    class="grey--text text--darken-1"
                    style="font-size: 14px; line-height: 1.4"
                  >
                    {{ card.subtitle }}
                  </span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "MethodologyPage",
  data() {
    return {
      pitchWhatsApp: `https://api.whatsapp.com/send?phone=${this.whatsApp()}&text=Ol%C3%A1%21+Vim+pelo+site+do+curso+e+gostaria+de+agendar+uma+aula+gratuita%21`,
      infoCards: [
        {
          icon: "mdi-rocket",
          title: "Acelere seu aprendizado!",
          subtitle:
            "Você fala inglês até 70% mais rápido do que em cursos tradicionais.",
        },
        {
          icon: "mdi-calendar",
          title: "Flexibilidade Total",
          subtitle:
            "Você tem liberdade total para escolher o melhor dia e horário para ter aula!",
        },
        {
          icon: "mdi-target",
          title: "Aulas Personalizadas",
          subtitle:
            "Escolha o formato de aula que preferir: individual, dupla, trio ou quarteto",
        },
      ],
    };
  },
  methods: {
    openLink() {
      window.open(
        "https://forms.clickup.com/3118765/f/2z5nd-7833/PVZ6XREQVLDC4EXCP7",
        "_blank"
      );
    },
    whatsApp() {
      return process.env.VUE_APP_PITCH_WPP.replaceAll(" ", "").replaceAll(
        "-",
        ""
      );
    },
  },
};
</script>

<style scoped>
.poppins {
  font-family: "Poppins", sans-serif !important;
  line-height: 1.6 !important;
  font-size: 1.1rem !important;
  text-align: justify;
}

.gradient {
  font-size: clamp(1.8rem, 4vw, 2.2rem); /* Fonte fluida que respeita o zoom */
  background: linear-gradient(to right, #e8276f, #9923cd);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 800;
}

/* Garante que os cards tenham a mesma altura mesmo com textos diferentes */
.infoCard {
  transition: transform 0.3s ease;
  min-height: 120px;
}
</style>
